import React, { useState, useEffect, useMemo } from "react";
import AddCurrency from "../Component/AddCurrency";
import CustomDataTable from "../../../Components/CustomTable/CustomTable";
import { Button, ButtonGroup, Col, Input, InputGroup, Row } from "reactstrap";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import { Link } from "react-router-dom";
import { Triangle } from "react-loader-spinner";
import CurrencyService from "../../../Services/QRCodeServices/CurrencyService/CurrencyService";
import DeleteModal from "../../../Components/Common/DeleteModal";
import toast from "react-hot-toast";
import EditCurrency from "../Component/EditCurrency";

const Currency = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [dataList, setDataList] = useState([]);
  const [data, setData] = useState([]);
  const [selectedEditItem, setSelectedEditItem] = useState(null);
  const [selectedDeleteItem, setSelectedDeleteItem] = useState(null);

  const toggleModal = () => {
    setModalOpen(!modalOpen);
  };

  const toggleEditModal = () => {
    setEditModalOpen(!editModalOpen);
  };

  const toggleDeleteModal = () => {
    setDeleteModal(!deleteModal);
  };

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await CurrencyService.getList();
      setData(response.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const anyModalJustClosed = useMemo(() => {
    return !editModalOpen || !modalOpen || !deleteModal;
  }, [editModalOpen, modalOpen, deleteModal]);

  useEffect(() => {
    if (anyModalJustClosed) {
      fetchData();
    }
  }, [anyModalJustClosed]);

  const handleDelete = async () => {
    if (selectedDeleteItem) {
      console.log(
        "🚀 ~ handleDelete ~ selectedDeleteItem:",
        selectedDeleteItem.id
      );
      try {
        await CurrencyService.delete(selectedDeleteItem.id);
        setDataList((prevList) =>
          prevList.filter((item) => item.id !== selectedDeleteItem.id)
        );
        toast.success("Currency deleted successfully");
      } catch (error) {
        console.log("🚀 ~ handleDelete ~ error:", error);
        toast.error("Failed to delete the currency");
      } finally {
        toggleDeleteModal();
        setSelectedDeleteItem(null);
        fetchData();
      }
    }
  };

  const handleDeleteClick = (item) => {
    setSelectedDeleteItem(item);
    toggleDeleteModal();
  };

  const handleEditClick = (item) => {
    setSelectedEditItem(item);
    toggleEditModal();
  };
  const [filterText, setFilterText] = useState("");
  const filteredData = data.filter((item) => {
    const searchText = filterText.toLowerCase();
    return item?.title?.toLowerCase().includes(searchText);
  });
  console.log("Data", data);
  console.log("filtered data", filteredData);

  const columns = [
    {
      name: "S.N",
      selector: (row, index) => index + 1,
      sortable: true,
      width: "75px",
    },
    {
      name: "Name",
      selector: (row) => (
        <Link to={`/currency/detail/${row?.id}`}>{row?.title}</Link>
      ),
      sortable: true,
    },
    {
      name: "Code",
      selector: (row) => `${row?.currencyCode || "N/A"}`,
      sortable: true,
    },
    {
      name: "Actions",
      cell: (row) => (
        <ButtonGroup className="gap-3">
          <Button
            color="warning"
            className="rounded-circle btn-sm d-flex align-items-center justify-content-center"
            style={{ width: "30px", height: "30px" }}
            onClick={() => handleEditClick(row)}
          >
            <i className="bx bx-edit"></i>
          </Button>
          <Button
            color="danger"
            className="rounded-circle btn-sm d-flex align-items-center justify-content-center"
            onClick={() => handleDeleteClick(row)}
            style={{ width: "30px", height: "30px" }}
          >
            <i className="bx bx-trash"></i>
          </Button>
        </ButtonGroup>
      ),
      center: true,
    },
  ];

  return (
    <div className="page-content">
      <div className="container-fluid">
        <BreadCrumb title="Currency List" pageTitle="Currency Management" />
      </div>
      <Row>
        <Col md={5} xs={6} className="px-xs-1">
          <InputGroup>
            <Input
              placeholder="Search by name"
              value={filterText}
              onChange={(e) => setFilterText(e.target.value)}
            />
          </InputGroup>
        </Col>
        <Col
          md={7}
          xs={6}
          className="d-flex justify-content-end align-items-end mb-3"
        >
          <Button className="package-button px-1 px-sm-2" onClick={toggleModal}>
            Add New Currency
          </Button>
        </Col>
      </Row>

      <CustomDataTable
        responsive
        striped
        pagination
        fixedHeader
        persistTableHead
        progressPending={loading}
        columns={columns}
        data={filteredData}
        customStyles={{
          headCells: {
            style: {
              fontSize: "0.93rem",
              fontWeight: 610,
            },
          },
          rows: {
            style: {
              fontSize: "0.9rem",
            },
          },
        }}
        progressComponent={
          <div className="my-3">
            <Triangle
              visible={true}
              height="80"
              width="80"
              color="#5B71B9"
              ariaLabel="triangle-loading"
              wrapperStyle={{}}
              wrapperClass=""
            />
            <h5 className="mt-1">Loading...</h5>
          </div>
        }
      />

      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDelete}
        onCloseClick={toggleDeleteModal}
        selectedItem={selectedDeleteItem}
      />
      <AddCurrency
        isOpen={modalOpen}
        toggleModal={toggleModal}
        refreshData={fetchData}
      />
      <EditCurrency
        isOpen={editModalOpen}
        toggleModal={toggleEditModal}
        data={selectedEditItem}
        refreshData={fetchData}
      />
    </div>
  );
};

export default Currency;
